// Формулы (4.6): выключная formula (номер справа, экспликация «где») и строчная mathInline.
// Храним LaTeX (источник истины для экспорта, writer/omml.py) и, если есть, MathML (для вставки/копирования).
import { Node, mergeAttributes } from '@tiptap/core';
import { idAttr, jsonAttr, registryNodeView } from './util';

export interface WhereItem { sym: string; desc: string }

export const Formula = Node.create({
  name: 'formula',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      ...idAttr(),
      latex: { default: '', parseHTML: (el) => el.getAttribute('data-latex') || '', renderHTML: (a) => ({ 'data-latex': a.latex }) },
      mathml: { default: null, parseHTML: (el) => el.getAttribute('data-mathml') || (el.tagName === 'MATH' ? el.outerHTML : null),
        renderHTML: () => ({}) },
      /** false - формула без номера (расчёт, 4.6.1.8) */
      numbered: { default: true, parseHTML: (el) => el.getAttribute('data-numbered') !== 'false',
        renderHTML: (a) => ({ 'data-numbered': a.numbered ? 'true' : 'false' }) },
      /** экспликация: [{sym: LaTeX символа, desc: текст (формулы в $…$)}] */
      where: jsonAttr<WhereItem[]>('where', []),
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="formula"]' }, { tag: 'math[display="block"]', priority: 60 }];
  },
  renderHTML({ node, HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'formula', class: 'sto-formula' }),
      ['span', { class: 'sto-formula-tex' }, node.attrs.latex || '(пустая формула)']];
  },
  addNodeView: registryNodeView('formula'),
});

export const MathInline = Node.create({
  name: 'mathInline',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      latex: { default: '', parseHTML: (el) => el.getAttribute('data-latex') || '', renderHTML: (a) => ({ 'data-latex': a.latex }) },
      mathml: { default: null, parseHTML: (el) => (el.tagName === 'MATH' ? el.outerHTML : null), renderHTML: () => ({}) },
    };
  },
  parseHTML() { return [{ tag: 'span[data-type="math-inline"]' }, { tag: 'math', priority: 50 }]; },
  renderHTML({ node, HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { 'data-type': 'math-inline', class: 'sto-math-inline' }), node.attrs.latex];
  },
  renderText({ node }) { return `$${node.attrs.latex}$`; },
  addNodeView: registryNodeView('mathInline'),
});

export const mathExtensions = () => [Formula, MathInline];
